<template>
  <div id="app" @mousemove="onMouseMove" @click="$hub.emit('click')" class="u-full-vp-width u-full-vp-height u-relative u-overflow-hidden">
    <div ref="baseContainerWebGL" class="u-wrapper-panel"/>
    <div ref="containerCSS3D" class="u-wrapper-panel u-pointer-none u-overflow-hidden"/>
    <div ref="objectContainerWebGL" class="u-wrapper-panel u-pointer-none"/>
    <scene v-if="loaded" />
  </div>
</template>

<script>
import App from './App'

import { webGL } from '@/webGL/WebGL'

import Scene from '@/components/Scene'

import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

import {
  AmbientLight,
  SphereGeometry,
  MeshNormalMaterial,
  Mesh
} from 'three'

export default {
  name: 'App',

  mixins: [App],

  components: {
    Scene
  },

  computed: {
    loaded () {
      return this.$store.getters['data/loaded']
    }
  },

  created () {
    this.pointerevent = null

    this.$store.commit('data/questions')
  },

  mounted () {
    this.onResize()
  },

  methods: {
    onUpdate (time) {
      if (this.pointerevent) {
        this.$device.setRaycast(this.pointerevent, webGL.camera)
      }

      this._onUpdate(time)
    },
    onMouseMove (event) {
      this.pointerevent = event
    }
  }
}
</script>

<style lang="stylus" src="./styles/theme.styl"/>

<!-- <style lang="stylus">
@import '~@/styles/settings/variables'
</style> -->
